import * as ImSdk from "../../../imsdk/api";


const getColorMain = () => {
    if (process.env.MISO_MODE === 'true' || process.env.MISO_MODE === '1') {
        return '#43C6A7';
    } else {
        return '#00ADEF';
    }
}

export const white = '#FFFFFF';
export const transparent = 'rgba(0,0,0,0)';
export const black = '#000000';
export const color_main = getColorMain();
export const color_F1F1F1 = '#F1F1F1';
export const color_EDEEF1 = '#EDEEF1';
export const color_A4AFCF = '#A4AFCF';
export const color_929292 = '#929292';
export const color_333333 = '#333333';
export const color_666666 = '#666666';
export const color_999999 = '#999999';
export const color_B1A8FF = '#B1A8FF';
export const color_B57BE6 = '#B57BE6';
export const color_7D9FFF = '#7D9FFF';
export const color_7CC3F9 = '#7CC3F9';
export const color_38E3C8 = '#38E3C8';
export const color_FF6E6E = '#FF6E6E';
export const color_3C3C3C = '#3C3C3C';
export const color_EEF2F9 = 'rgba(238,242,249,1)';
export const color_BEBEBE = '#BEBEBE';
export const color_E9E9E9 = '#E9E9E9';
export const color_EEF3FA = '#EEF3FA';
export const color_BBBBBB = '#BBBBBB';
export const color_2A2A2A = '#2A2A2A';
export const color_8C8C8C = '#8C8C8C';
export const color_9F9E9E = '#9F9E9E';
export const color_1E1E1E = '#1E1E1E';
export const ColorLine = '#D5D9DF';
export const ColorGrey = '#F1F1F4';
export const Color50F1AB = '#50F1AB';
export const Color43C6A7 = '#43C6A7';
export const ColorCEFFF2 = '#CEFFF2';
export const ColorF6F6F6 = '#F6F6F6';
export const ColorF5F5F5 = '#F5F5F5';
export const Color979797 = '#979797';
export const Color71717A = '#71717A';
export const ColorC5EAE1 = '#C5EAE1';
export const ColorF4F4F4 = '#F4F4F4';

export const ColorGreen = '#4BCB41';
export const ColorBlue = '#1485EE';
export const ColorPurple = '#6467EF';
export const ColorRed = '#FF4040';
export const color_E43737 = '#e43737';
export const ColorOrange = '#FFBA1B';

export const primary50 = '#F2F2F2';
export const primary100 = '#CDE0EC';
export const primary200 = '#C0DBFD';
export const primary300 = '#F2F2F2';
export const primary400 = '#F2F2F2';
export const primary500 = '#F2F2F2';
export const primary600 = '#F2F2F2';
export const primary700 = '#F2F2F2';
export const primary800 = '#F2F2F2';
export const primary900 = '#F2F2F2';
export const primary950 = '#F2F2F2';
export const black30 = 'rgba(0,0,0,0.3)';
export const black10 = 'rgba(0,0,0,0.1)';
export const black50 = 'rgba(0,0,0,0.5)';

export const black90 = 'rgba(0,0,0,0.9)';

export const white30 = 'rgba(255,255,255,0.3)';
export const white80 = 'rgba(255,255,255,0.8)';
